export const FromComeLocationEnum = {
  INIT: 'init',
  LEFT: 'left',
} as const
export type FromComeLocationEnum =
  (typeof FromComeLocationEnum)[keyof typeof FromComeLocationEnum]
